import classnames from 'classnames';
import styles from './styles.module.scss';
import {NextImg} from '@/utils/nextImg';
import {useStore} from '@/store/root-store';

export enum notificationType {
  success = 'success',
  info = 'info',
  warning = 'warning',
  error = 'error',
}

interface Props {
  type: notificationType;
  text: string;
  showContactSupportLink?: boolean;
}

export const Notification = ({type, text, showContactSupportLink = false} : Props) => {
  const {settings: {customer: {isGHLAccount}}} = useStore('');
  const openLiveChat = () => {
    const chatBtn: HTMLElement = document.querySelector('.cc-unoo') as HTMLElement;
    if (chatBtn) {
      chatBtn.click();
    }
  };

  return (
    <div className={classnames(styles.notification,
      {[styles.success]: type === notificationType.success},
      {[styles.info]: type === notificationType.info},
      {[styles.warning]: type === notificationType.warning},
      {[styles.error]: type === notificationType.error})}
    >
      {type === notificationType.error && <NextImg src='/img/icon/errorNotification.svg' />}
      <span>{text}</span>{isGHLAccount ? '' : showContactSupportLink && <span className={styles.contactLink} onClick={() => openLiveChat()}> contact our support team</span>}
    </div>
  );
};
